import { getMarkdown } from "~/data/static";

export const getBrandTncData = async (resId: string): Promise<string> => {
  return await getMarkdown(resId);
};
